/**
 * The ONE set of request headers the add-in's browser code sends to the
 * Product API (outlook-orachat-uplift s4, design C4). `orchestratorApi`, the
 * oraChat panel's transport (which also carries the panel's voice clients)
 * and the chat-user read all take their header names from here.
 *
 * Every name here must survive both hops a browser call can take:
 *  - the add-in host relay (`relay.mjs` FORWARDED_REQUEST_HEADERS) — the
 *    production path since US28491; it silently DROPS any other header;
 *  - the Product API's `OutlookPluginCors` policy (`api/Product.Api/Program.cs`
 *    `WithHeaders`) — a cross-origin caller (the proof harness's `apiBase`)
 *    fails the preflight on any other header.
 * `oraHeaders.test.ts` parses both files and fails on a miss, so adding a
 * header here means adding it to both lists in the same change.
 */
export const ORA_ADDIN_HEADERS = {
  authorization: "Authorization",
  contentType: "Content-Type",
  correlationId: "x-correlation-id",
  /** The UI surface a call came from; the API forwards it as X-Caller-Surface. */
  surface: "X-Ora-Surface",
  /** Read by OraChatProxyController on the voice routes (values: s9). */
  oraChatHost: "X-OraChat-Host",
  /** Per-window hands-free instance id (values: s9). */
  surfaceInstance: "X-Ora-Surface-Instance",
} as const;

/** Every shared header name, as spelled on the wire. */
export const ORA_ADDIN_HEADER_NAMES: readonly string[] = Object.freeze(
  Object.values(ORA_ADDIN_HEADERS),
);

/** The `X-Ora-Surface` value every add-in call carries. */
export const ORA_ADDIN_SURFACE_STAMP = "outlook_addin";

/** `X-OraChat-Host` on the voice routes only (s9). A per-window voice host. */
export const ORA_ADDIN_VOICE_HOST_TAG = "outlook-addin";
